<upp-pinpad-home
    [ticketDetailTpl]="ticketDetailTpl"
    [tableDetailTpl]="tableDetailTpl"
    [cartTpl]="cartTpl"
    [ticketsTpl]="ticketsTpl"
    #home
>
</upp-pinpad-home>

<ng-template #ticketDetailTpl let-work>
    <upp-ticket-edit
        [place]="work.place"
        [ticket]="work.DetailTicket"
        [mode]="work.DetailMode"
        (ToPanel)="OnHomePanel(home, $event)"
    ></upp-ticket-edit>
</ng-template>

<ng-template #tableDetailTpl let-work>
    <upp-table-edit
        [place]="work.place"
        [table]="work.DetailTable"
        (ToPanel)="OnHomePanel(home, $event)"
    ></upp-table-edit>
</ng-template>

<ng-template #cartTpl>
    <app-ptf-cart (OnPanel)="OnHomePanel(home, $event)"></app-ptf-cart>
</ng-template>

<ng-template #ticketsTpl let-work>
    <app-ptf-tickets [work]="work"></app-ptf-tickets>
</ng-template>
